import React, { useMemo } from "react";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { StyledBaseStack, StyledCardStack, StyledPrintWrapper } from "./styles";
import { theme as createAppTheme } from "../../theme";

const NoPageStylePrintArea = ({ id, flip, margin, children }) => {
  const scope = `print-area-${id}`;
  const orientation = flip ? "landscape" : "portrait";

  const width = flip ? "11in" : "8.5in";
  const height = flip ? "8.5in" : "11in";

  return (
    <>
      <style>{`
        @media print {
          @page { size: letter ${orientation}; margin: ${margin}in; }
          html, body { background: #fff !important; }
          body * { visibility: hidden !important; }
          .${scope}, .${scope} * { visibility: visible !important; }
          .${scope} {
            display: block !important;
            position: absolute;
            inset: 0;
            overflow: visible !important;
            padding: 0 !important;
            background: #fff !important;
          }
          .${scope} .print-break-avoid {
            break-inside: avoid;
            page-break-inside: avoid;
          }
        }
      `}</style>
      <StyledPrintWrapper className={scope} id={id} style={{ width, height }}>
        {children}
      </StyledPrintWrapper>
    </>
  );
};

export const PagePrint = ({
  id = "printed-sheet",
  margin = 0.25,
  cardProps = {},
  stackProps = {},
  flip = false,
  pageless = false,
  noPageStyle = false,
  disableMinHeight = false,
  children,
  themed = true,
}) => {
  const currentTheme = useTheme();
  const color = currentTheme.palette?.hubColors?.mainFocus;

  const lightTheme = useMemo(() => createAppTheme(false, color), [color]);

  if (noPageStyle) {
    return (
      <NoPageStylePrintArea id={id} flip={flip} margin={margin}>
        {children}
      </NoPageStylePrintArea>
    );
  }

  const width = flip ? "11in" : "8.5in";
  const fixedHeight = flip ? "8.5in" : "11in";

  const unthemed = (
    <StyledCardStack
      className="print-only"
      id={id}
      width={width}
      {...(pageless
        ? {
            ...(!disableMinHeight && { minHeight: fixedHeight }),
            height: "fit-content",
          }
        : { height: fixedHeight })}
      borderRadius={0}
      m="auto"
      margin={margin}
      {...cardProps}
    >
      <StyledBaseStack
        width={width}
        margin={margin}
        pageless={pageless}
        fixedHeight={fixedHeight}
        {...stackProps}
      >
        {children}
      </StyledBaseStack>
    </StyledCardStack>
  );
  return themed ? (
    <ThemeProvider theme={lightTheme}>{unthemed}</ThemeProvider>
  ) : (
    unthemed
  );
};

export default PagePrint;
